// components/QuizModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Typography, Radio, RadioGroup, FormControlLabel } from '@mui/material';

const QuizModal = ({ open, onClose }) => {
  const [answers, setAnswers] = useState({});

  const handleSubmit = () => {
    alert('Quiz submitted!');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div style={{ padding: '20px', background: 'white', margin: '20px' }}>
        <Typography variant="h6">Quiz</Typography>
        <RadioGroup>
          <FormControlLabel value="A" control={<Radio />} label="Option A" />
          <FormControlLabel value="B" control={<Radio />} label="Option B" />
          <FormControlLabel value="C" control={<Radio />} label="Option C" />
        </RadioGroup>
        <Button variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default QuizModal;